import DocDocument from "@shared/svg/doc-document.svg?react";
import EmlDocument from "@shared/svg/eml-document.svg?react";
import EpubDocument from "@shared/svg/epub-document.svg?react";
import HtmlDocument from "@shared/svg/html-document.svg?react";
import ImageDocument from "@shared/svg/image-document.svg?react";
import JsonDocument from "@shared/svg/json-document.svg?react";
import LxmlDocument from "@shared/svg/lxml-document.svg?react";
import MdDocument from "@shared/svg/md-document.svg?react";
import OdtDocument from "@shared/svg/odt-document.svg?react";
import PbDocument from "@shared/svg/pb-document.svg?react";
import PdfDocument from "@shared/svg/pdf-document.svg?react";
import PptDocument from "@shared/svg/ppt-document.svg?react";
import RtfDocument from "@shared/svg/rtf-document.svg?react";
import TxtDocument from "@shared/svg/txt-document.svg?react";
import VideoDocument from "@shared/svg/video.svg?react";
import XlsDocument from "@shared/svg/xls-document.svg?react";
import React from "react";

/**
 * File-type icons for knowledge-base documents, shared by oem and the portal's
 * document preview. Moved from oem — the two maps from
 * `~/services/ai-assistant/constants` and `~/constants/emails`, the fallback
 * icon from `~/icons/icons` — all of which re-export from here.
 */

export const SUPPORTED_FILE_EXTENSIONS = {
  md: MdDocument,
  pdf: PdfDocument,
  doc: DocDocument,
  docx: DocDocument,
  pptx: PptDocument,
  xlsx: DocDocument,
  txt: TxtDocument,
  html: HtmlDocument,
  json: JsonDocument,
  eml: EmlDocument,
  msg: EmlDocument,
  jpg: ImageDocument,
  jpeg: ImageDocument,
  png: ImageDocument,
  gif: ImageDocument,
  mpo: ImageDocument,
  webp: ImageDocument,
  avif: ImageDocument,
  heif: ImageDocument,
};

export const SUPPORTED_EMAIL_FILE_EXTENSIONS = {
  md: MdDocument,
  pdf: PdfDocument,
  odt: OdtDocument,
  doc: DocDocument,
  docx: DocDocument,
  ppt: PptDocument,
  pptx: PptDocument,
  txt: TxtDocument,
  html: HtmlDocument,
  lxml: LxmlDocument,
  rtf: RtfDocument,
  epub: EpubDocument,
  pb: PbDocument,
  pbtxt: PbDocument,
  json: JsonDocument,
  eml: EmlDocument,
  png: ImageDocument,
  tiff: ImageDocument,
  jpg: ImageDocument,
  jpeg: ImageDocument,
  csv: XlsDocument,
  xls: XlsDocument,
  xlsx: XlsDocument,
  mp4: VideoDocument,
};

export const DocumentTypeIcon = ({ strokeColor = "#828B9D", ...props }) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.7061 11.1856L25.99 6.46945C25.3646 5.84407 24.5157 5.49219 23.6319 5.49219H11.6713C9.82851 5.49219 8.33594 6.98476 8.33594 8.82754V32.175C8.33594 34.0178 9.82851 35.5103 11.6713 35.5103H28.348C30.1908 35.5103 31.6834 34.0178 31.6834 32.175V13.5437C31.6834 12.6599 31.3315 11.811 30.7061 11.1856V11.1856Z"
      stroke={strokeColor}
      strokeWidth="1.87613"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.6821 13.8306H25.0114C24.0909 13.8306 23.3438 13.0834 23.3438 12.1629V5.49219"
      stroke={strokeColor}
      strokeWidth="1.87613"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** oem's lookup order: the assistant map, then the email map. */
export const getDocumentFileIcon = (extension?: string) =>
  extension
    ? (SUPPORTED_FILE_EXTENSIONS as Record<string, React.ComponentType<{ className?: string }>>)[extension] ||
      (SUPPORTED_EMAIL_FILE_EXTENSIONS as Record<string, React.ComponentType<{ className?: string }>>)[extension]
    : undefined;
